import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Layout
      'Copy URL': 'Copy URL',
      'Copied URL': 'Copied URL',
      'Share': 'Share',
      'Hide chat history': 'Hide chat history',
      'Show chat history': 'Show chat history',
      'Hide history': 'Hide history',
      'Show history': 'Show history',
      'Share the web app': 'Share the web app',
      // Chat
      'Authentication Not Configured': 'Authentication Not Configured',
      'This app does not have authentication configured. Please add an identity provider by finding your app in the': 'This app does not have authentication configured. Please add an identity provider by finding your app in the',
      'Azure Portal': 'Azure Portal',
      'these instructions': 'these instructions',
      'Authentication configuration takes a few minutes to apply.': 'Authentication configuration takes a few minutes to apply.',
      'If you deployed in the last 10 minutes, please wait and reload the page after 10 minutes.': 'If you deployed in the last 10 minutes, please wait and reload the page after 10 minutes.',
      'Generating answer...': 'Generating answer...',
      'Error': 'Error',
      'Stop generating': 'Stop generating',
      'start a new chat button': 'start a new chat button',
      'start a new chat': 'start a new chat',
      'clear chat button': 'clear chat button',
      'clear chat': 'clear chat',
      'Citations': 'Citations',
      'Close citations panel': 'Close citations panel',
      'Intents Panel': 'Intents Panel',
      'Intents': 'Intents',
      'Close intents panel': 'Close intents panel',
      'Intent:': 'Intent:',
      'Search Query:': 'Search Query:',
      'Search Result:': 'Search Result:',
      'Code Generated:': 'Code Generated:',
      'No content in messages object.': 'No content in messages object.',
      'An error occurred. Please try again. If the problem persists, please contact the site administrator.': 'An error occurred. Please try again. If the problem persists, please contact the site administrator.',
      'There was an error generating a response. Chat history can\'t be saved at this time.': 'There was an error generating a response. Chat history can\'t be saved at this time.',
      'An error occurred.': 'An error occurred.',
      'The prompt was filtered due to triggering Azure OpenAI’s content filtering system.': 'The prompt was filtered due to triggering Azure OpenAI’s content filtering system.',
      'Reason: This prompt contains content flagged as ': 'Reason: This prompt contains content flagged as ',
      'Jailbreak': 'Jailbreak',
      'Please modify your prompt and retry. Learn more: https://go.microsoft.com/fwlink/?linkid=2198766': 'Please modify your prompt and retry. Learn more: https://go.microsoft.com/fwlink/?linkid=2198766',
      'An error occurred. Answers can\'t be saved at this time. If the problem persists, please contact the site administrator.': 'An error occurred. Answers can\'t be saved at this time. If the problem persists, please contact the site administrator.',
      'Uploaded Preview': 'Uploaded Preview',
      'Type a new question...': 'Type a new question...',
      'Dialog title': 'Dialog title',
      'Dialog subtitle': 'Dialog subtitle',
      // Answer
      "Why wasn't this response helpful?": "Why wasn't this response helpful?",
      'Citations are missing': 'Citations are missing',
      'Citations are wrong': 'Citations are wrong',
      'The response is not from my data': 'The response is not from my data',
      'Inaccurate or irrelevant': 'Inaccurate or irrelevant',
      'Other': 'Other',
      'Report inappropriate content': 'Report inappropriate content',
      'The content is': 'The content is',
      'Hate speech, stereotyping, demeaning': 'Hate speech, stereotyping, demeaning',
      'Violent: glorification of violence, self-harm': 'Violent: glorification of violence, self-harm',
      'Sexual: explicit content, grooming': 'Sexual: explicit content, grooming',
      'Manipulative: devious, emotional, pushy, bullying': 'Manipulative: devious, emotional, pushy, bullying',
      'AI-generated content may be incorrect': 'AI-generated content may be incorrect',
      'references': 'references',
      'reference': 'reference',
      'Answer based on the following sources:': 'Answer based on the following sources:',
      'Like this response': 'Like this response',
      'Dislike this response': 'Dislike this response',
      'noDataFound': 'I am sorry, but I was not able to find a suitable answer to your question at this time. Do you have a specific question? Feel free to try again with a bit more explanation so I can assist you better.',
      // QuestionInput
      'Upload Image': 'Upload Image',
      'Ask question button': 'Ask question button',
      'Ask question': 'Ask question',
      // NoPage
      '404': '404',
      // CosmosDB Status
      'CosmosDB is not configured': 'CosmosDB is not configured',
      'CosmosDB is not working': 'CosmosDB is not working',
      'CosmosDB has invalid credentials': 'CosmosDB has invalid credentials',
      'Invalid CosmosDB database name': 'Invalid CosmosDB database name',
      'Invalid CosmosDB container name': 'Invalid CosmosDB container name',
      'CosmosDB is configured and working': 'CosmosDB is configured and working',
      // Feedback Types
      'neutral': 'neutral',
      'positive': 'positive',
      'negative': 'negative',
      'missing_citation': 'missing_citation',
      'wrong_citation': 'wrong_citation',
      'out_of_scope': 'out_of_scope',
      'inaccurate_or_irrelevant': 'inaccurate_or_irrelevant',
      'other_unhelpful': 'other_unhelpful',
      'hate_speech': 'hate_speech',
      'violent': 'violent',
      'sexual': 'sexual',
      'manipulative': 'manipulative',
      'other_harmlful': 'other_harmlful',
      'Chat history is not enabled': 'Chat history is not enabled',
      'Please contact the site administrator.': 'Please contact the site administrator.',
      'Error clearing current chat': 'Error clearing current chat',
      'An error occurred. Please try again.': 'An error occurred. Please try again.',
      'An error occurred. Answers cannot be saved.': 'An error occurred. Answers cannot be saved.',
      'Your feedback will improve this experience.': 'Your feedback will improve this experience.',
      'By pressing submit, your feedback will be visible.': 'By pressing submit, your feedback will be visible to the application owner.',
      'Please provide additional details...': 'Please provide additional details...',
      'Submit': 'Submit',
      'Submit Feedback': 'Submit',
      // Common Dialog
      'Close dialog': 'Close dialog',
      // References
      'reference_count': '{{count}} reference',
      'reference_count_plural': '{{count}} references',
      'citation_index': 'Citation {{index}}',
      // Chat History
      'Are you sure you want to clear all chat history?': 'Are you sure you want to clear all chat history?',
      'Error deleting all of chat history': 'Error deleting all of chat history',
      'All chat history will be permanently removed.': 'All chat history will be permanently removed.',
      'Clear all chat history': 'Clear all chat history',
      'chat history panel': 'chat history panel',
      'chat history header': 'chat history header',
      'Chat history': 'Chat history',
      'Hide': 'Hide',
      'hide button': 'hide button',
      'chat history panel content': 'chat history panel content',
      'Error loading chat history': 'Error loading chat history',
      "Chat history can't be saved at this time": "Chat history can't be saved at this time",
      'Loading chat history': 'Loading chat history',
      'Clear All': 'Clear All',
      'Cancel': 'Cancel',
      'Are you sure you want to delete this item?': 'Are you sure you want to delete this item?',
      'The history of this chat session will permanently removed.': 'The history of this chat session will permanently removed.',
      'Error: Enter a new title to proceed.': 'Error: Enter a new title to proceed.',
      'Error: could not rename item': 'Error: could not rename item',
      'chat history item': 'chat history item',
      'edit title form': 'edit title form',
      'action button group': 'action button group',
      'confirm new title': 'confirm new title',
      'cancel edit title': 'cancel edit title',
      'Delete': 'Delete',
      'Edit': 'Edit',
      'Error: could not delete item': 'Error: could not delete item',
      'loading more chat history': 'loading more chat history',
      'chat history group: {{month}}': 'chat history group: {{month}}',
      'chat history list': 'chat history list',
      'January': 'January',
      'February': 'February',
      'March': 'March',
      'April': 'April',
      'May': 'May',
      'June': 'June',
      'July': 'July',
      'August': 'August',
      'September': 'September',
      'October': 'October',
      'November': 'November',
      'December': 'December'
    }
  },
  nl: {
    translation: {
      // Layout
      'Copy URL': 'Kopieer URL',
      'Copied URL': 'URL gekopieerd',
      'Share': 'Delen',
      'Hide chat history': 'Chatgeschiedenis verbergen',
      'Show chat history': 'Chatgeschiedenis tonen',
      'Hide history': 'Geschiedenis verbergen',
      'Show history': 'Geschiedenis tonen',
      'Share the web app': 'Deel de webapp',
      // Chat
      'Authentication Not Configured': 'Authenticatie niet geconfigureerd',
      'This app does not have authentication configured. Please add an identity provider by finding your app in the': 'Deze app heeft geen authenticatie geconfigureerd. Voeg een identiteitsprovider toe door je app te vinden in de',
      'Azure Portal': 'Azure Portal',
      'these instructions': 'deze instructies',
      'Authentication configuration takes a few minutes to apply.': 'Het configureren van authenticatie duurt enkele minuten.',
      'If you deployed in the last 10 minutes, please wait and reload the page after 10 minutes.': 'Als je in de afgelopen 10 minuten hebt gedeployed, wacht dan en herlaad de pagina na 10 minuten.',
      'Generating answer...': 'Antwoord wordt gegenereerd...',
      'Error': 'Fout',
      'Stop generating': 'Stop met genereren',
      'start a new chat button': 'start een nieuwe chat knop',
      'start a new chat': 'start een nieuwe chat',
      'clear chat button': 'wis chat knop',
      'clear chat': 'wis chat',
      'Citations': 'Bronvermeldingen',
      'Close citations panel': 'Sluit bronvermeldingenpaneel',
      'Intents Panel': 'Intentiespaneel',
      'Intents': 'Intenties',
      'Close intents panel': 'Sluit intentiespaneel',
      'Intent:': 'Intentie:',
      'Search Query:': 'Zoekopdracht:',
      'Search Result:': 'Zoekresultaat:',
      'Code Generated:': 'Gegenereerde code:',
      'No content in messages object.': 'Geen inhoud in berichtenobject.',
      'An error occurred. Please try again. If the problem persists, please contact the site administrator.': 'Er is een fout opgetreden. Probeer het opnieuw. Als het probleem aanhoudt, neem dan contact op met de sitebeheerder.',
      'There was an error generating a response. Chat history can\'t be saved at this time.': 'Er is een fout opgetreden bij het genereren van een antwoord. Chatgeschiedenis kan op dit moment niet worden opgeslagen.',
      'An error occurred.': 'Er is een fout opgetreden.',
      'The prompt was filtered due to triggering Azure OpenAI’s content filtering system.': 'De prompt is gefilterd omdat het Azure OpenAI\'s inhoudsfiltersysteem heeft geactiveerd.',
      'Reason: This prompt contains content flagged as ': 'Reden: Deze prompt bevat inhoud die is gemarkeerd als ',
      'Jailbreak': 'Jailbreak',
      'Please modify your prompt and retry. Learn more: https://go.microsoft.com/fwlink/?linkid=2198766': 'Pas uw prompt aan en probeer het opnieuw. Meer informatie: https://go.microsoft.com/fwlink/?linkid=2198766',
      'An error occurred. Answers can\'t be saved at this time. If the problem persists, please contact the site administrator.': 'Er is een fout opgetreden. Antwoorden kunnen op dit moment niet worden opgeslagen. Als het probleem aanhoudt, neem dan contact op met de sitebeheerder.',
      'Uploaded Preview': 'Geüploade voorvertoning',
      'Type a new question...': 'Typ een nieuwe vraag...',
      'Dialog title': 'Dialoogtitel',
      'Dialog subtitle': 'Dialoog ondertitel',
      // Answer
      "Why wasn't this response helpful?": "Waarom was dit antwoord niet behulpzaam?",
      'Citations are missing': 'Bronvermeldingen ontbreken',
      'Citations are wrong': 'Bronvermeldingen zijn onjuist',
      'The response is not from my data': 'Het antwoord komt niet uit mijn data',
      'Inaccurate or irrelevant': 'Onnauwkeurig of niet relevant',
      'Other': 'Anders',
      'Report inappropriate content': 'Ongepaste inhoud rapporteren',
      'The content is': 'De inhoud is',
      'Hate speech, stereotyping, demeaning': 'Haatdragend, stereotyperend, kleinerend',
      'Violent: glorification of violence, self-harm': 'Geweld: verheerlijken van geweld, zelfbeschadiging',
      'Sexual: explicit content, grooming': 'Seksueel: expliciete inhoud, grooming',
      'Manipulative: devious, emotional, pushy, bullying': 'Manipulatief: sluw, emotioneel, opdringerig, pesten',
      'AI-generated content may be incorrect': 'AI-gegenereerde inhoud kan onjuist zijn',
      'references': 'referenties',
      'reference': 'referentie',
      'Answer based on the following sources:': 'Antwoord gebaseerd op de volgende bronnen:',
      'Like this response': 'Vind deze reactie leuk',
      'Dislike this response': 'Vind deze reactie niet leuk',
      'noDataFound': 'Het spijt me, maar ik heb op dit moment geen passend antwoord op je vraag kunnen vinden. Heb je een specifieke vraag? Probeer het dan gerust opnieuw met wat meer uitleg, zodat ik je beter kan helpen.',
      // QuestionInput
      'Upload Image': 'Afbeelding uploaden',
      'Ask question button': 'Stel vraag knop',
      'Ask question': 'Stel je vraag',
      // NoPage
      '404': '404',
      // CosmosDB Status
      'CosmosDB is not configured': 'CosmosDB is niet geconfigureerd',
      'CosmosDB is not working': 'CosmosDB werkt niet',
      'CosmosDB has invalid credentials': 'CosmosDB heeft ongeldige inloggegevens',
      'Invalid CosmosDB database name': 'Ongeldige CosmosDB-databasenaam',
      'Invalid CosmosDB container name': 'Ongeldige CosmosDB-containernaam',
      'CosmosDB is configured and working': 'CosmosDB is geconfigureerd en werkt',
      // Feedback Types
      'neutral': 'neutraal',
      'positive': 'positief',
      'negative': 'negatief',
      'missing_citation': 'ontbrekende_bron',
      'wrong_citation': 'onjuiste_bron',
      'out_of_scope': 'buiten_bereik',
      'inaccurate_or_irrelevant': 'onnauwkeurig_of_niet_relevant',
      'other_unhelpful': 'anders_niet_bruikbaar',
      'hate_speech': 'haatspraak',
      'violent': 'gewelddadig',
      'sexual': 'seksueel',
      'manipulative': 'manipulatief',
      'other_harmlful': 'anders_schadelijk',
      'Chat history is not enabled': 'Chatgeschiedenis is niet ingeschakeld',
      'Please contact the site administrator.': 'Neem contact op met de sitebeheerder.',
      'Error clearing current chat': 'Fout bij het wissen van de huidige chat',
      'An error occurred. Please try again.': 'Er is een fout opgetreden. Probeer het opnieuw.',
      'An error occurred. Answers cannot be saved.': 'Er is een fout opgetreden. Antwoorden kunnen niet worden opgeslagen.',
      'Your feedback will improve this experience.': 'Uw feedback zal deze ervaring verbeteren.',
      'By pressing submit, your feedback will be visible.': 'Door op verzenden te drukken, is uw feedback zichtbaar voor de eigenaar van de applicatie.',
      'Please provide additional details...': 'Geef aanvullende details...',
      'Submit': 'Verzenden',
      'Submit Feedback': 'Feedback verzenden',
      // Common Dialog
      'Close dialog': 'Dialoog sluiten',
      // References
      'reference_count': '{{count}} referentie',
      'reference_count_plural': '{{count}} referenties',
      'citation_index': 'Bronvermelding {{index}}',
      // Chat History
      'Are you sure you want to clear all chat history?': 'Weet u zeker dat u alle chatgeschiedenis wilt wissen?',
      'Error deleting all of chat history': 'Fout bij het verwijderen van alle chatgeschiedenis',
      'All chat history will be permanently removed.': 'Alle chatgeschiedenis wordt permanent verwijderd.',
      'Clear all chat history': 'Wis alle chatgeschiedenis',
      'chat history panel': 'chatgeschiedenispaneel',
      'chat history header': 'chatgeschiedeniskop',
      'Chat history': 'Chatgeschiedenis',
      'Hide': 'Verbergen',
      'hide button': 'verberg knop',
      'chat history panel content': 'inhoud chatgeschiedenispaneel',
      'Error loading chat history': 'Fout bij laden van chatgeschiedenis',
      "Chat history can't be saved at this time": 'Chatgeschiedenis kan momenteel niet worden opgeslagen',
      'Loading chat history': 'Chatgeschiedenis laden',
      'Clear All': 'Alles wissen',
      'Cancel': 'Annuleren',
      'Are you sure you want to delete this item?': 'Weet u zeker dat u dit item wilt verwijderen?',
      'The history of this chat session will permanently removed.': 'De geschiedenis van deze chatsessie wordt permanent verwijderd.',
      'Error: Enter a new title to proceed.': 'Fout: Voer een nieuwe titel in om verder te gaan.',
      'Error: could not rename item': 'Fout: kan item niet hernoemen',
      'chat history item': 'chatgeschiedenisitem',
      'edit title form': 'titelformulier bewerken',
      'action button group': 'actieknopgroep',
      'confirm new title': 'bevestig nieuwe titel',
      'cancel edit title': 'annuleer bewerkte titel',
      'Delete': 'Verwijderen',
      'Edit': 'Bewerken',
      'Error: could not delete item': 'Fout: kan item niet verwijderen',
      'loading more chat history': 'meer chatgeschiedenis laden',
      'chat history group: {{month}}': 'chatgeschiedenisgroep: {{month}}',
      'chat history list': 'chatgeschiedenislijst',
      'January': 'Januari',
      'February': 'Februari',
      'March': 'Maart',
      'April': 'April',
      'May': 'Mei',
      'June': 'Juni',
      'July': 'Juli',
      'August': 'Augustus',
      'September': 'September',
      'October': 'Oktober',
      'November': 'November',
      'December': 'December'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'nl',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
